import styled from 'styled-components';
import {media} from '../../styles/components/media-queries';

export const BasketTotalStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: ${p => p.theme.menuPage.basket.total.fontSize};
  background-color: ${p => p.theme.menuPage.basket.total.backgroundColor};
  color: ${p => p.theme.menuPage.basket.total.color};
  padding: ${p => p.theme.menuPage.basket.total.padding};
  border-top: ${p => p.theme.menuPage.basket.total.border};
  font-weight: bold;
  font-family: ${p => p.theme.menuPage.basket.total.fontFamily};
  visibility: ${props => props.isExpanded ? 'hidden' : 'visible'};
  ${media.small`
    background-color: transparent;
    color: ${props => props.theme.primaryColor};
    border-top-color: ${props => props.theme.borderColorRevert};
    border-top-width: 0;
    margin-top: 0;
    display: flex;
    align-items: flex-end;
    ${p => p.theme.menuPage.basket.total.paddingSmall && `padding: ${p.theme.menuPage.basket.total.paddingSmall};`}
  `};
`;

export const Total = styled.span`
  text-transform: ${p => p.theme.menuPage.basket.total.textTransform};
  ${media.small`
    display: none;
  `};
`;

export const PriceRow = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const MessageRow = styled.div`
  color: ${props => props.theme.sideBasket.message};
  font-size: ${props => props.theme.sideBasket.option.fontSize};
  margin-top: ${props => props.theme.margin};
  ${media.small`
    display: none;
  `};
`;



// WEBPACK FOOTER //
// ./components/BasketBar/BasketTotal.style.js